<template>
	<v-dialog v-model="dialog" max-width="600px">
		<v-card>
			<v-app-bar dense dark flat color="primary">
				<v-app-bar-title class="color-white">部品追加</v-app-bar-title>
				<v-spacer />
				<v-btn icon dark @click="dialog = false" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-app-bar>
			<v-card-text class="pa-2">
				<v-form ref="form" lazy-validation>
					<v-row class="d-flex flex-wrap justify-center" no-gutters v-if="!selectedComponent">
						<v-text-field
							type="text"
							v-model="searchWord"
							class="mt-2 mx-1"
							label="部品名"
							outlined
							dense
						/>
						<v-text-field
							type="text"
							v-model="searchNumber"
							class="mt-2 mx-1"
							label="品番"
							outlined
							dense
						/>
					</v-row>
					<v-row no-gutters justify="space-around" v-if="!selectedComponent">
						<v-btn
							:disabled="!searchWord && !searchNumber"
							class="ma-2 pa-2 mt-4"
							color="primary"
							@click="searchComponent()"
							><v-icon>mdi-magnify</v-icon>検索</v-btn
						>
					</v-row>
					<v-row no-gutters justify="space-around"
						><v-btn
							class="ma-2 pa-2 pre-wrap height100p text-align-left"
							v-for="component in searchedComponents"
							:key="component.id"
							v-text="componentInfo(component)"
							@click="setComponent(component)"
						></v-btn
					></v-row>
					<v-row v-if="selectedComponent" class="d-flex flex-wrap" no-gutters>
						<v-card
							><v-container
								><v-row no-gutters class="pa2" justify="end"
									><v-icon @click="resetComponent">mdi-delete</v-icon></v-row
								>
								<v-row no-gutters class="pa2" justify="center"
									><p
										class="pre-wrap"
										v-text="componentInfo(selectedComponent)"
									></p></v-row></v-container
						></v-card>
					</v-row>
					<v-row v-if="selectedComponent" class="d-flex flex-wrap justify-center" no-gutters>
						<v-text-field
							type="number"
							v-model="orderComponent.quantity"
							class="mt-2 mx-1"
							label="数量"
							outlined
							dense
						/>
						<v-text-field
							type="number"
							v-model="orderComponent.unit_price"
							class="mt-2 mx-1"
							label="単価"
							outlined
							dense
						/>
					</v-row>
					<v-row v-if="selectedComponent" class="d-flex flex-wrap justify-center" no-gutters>
						<v-textarea
							v-model="orderComponent.remarks"
							class="mt-2 mx-1"
							label="備考"
							outlined
							dense
						/>
					</v-row>
					<DragUpload
						v-if="selectedComponent && selectedComponent.wildcard"
						@fileShare="fileShare"
					/>
					<v-row v-if="selectedComponent" class="d-flex flex-wrap justify-center" no-gutters>
						<v-btn
							v-if="selectedComponent"
							:disabled="!orderComponent.quantity"
							class="ma-2 pa-2 mt-4"
							color="primary"
							@click="createOrderComponent()"
							>追加</v-btn
						>
					</v-row>
				</v-form>
			</v-card-text>
			<v-card-actions>
				<v-row no-gutters> </v-row>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import moment from "moment"
import axios from "axios"
import authenticate from "../../../helper/authenticate"
import errorHandling from "../../../helper/errorHandling"
import common from "../../../helper/common"
import rules from "../../../helper/rules"
import FunctionTitle from "../../shared/FunctionTitle.vue"
import CommonFlame from "../../shared/CommonFlame.vue"
import DragUpload from "../../shared/DragUpload.vue"

function initialState() {
	return {
		common: common,
		dialog: false,
		ordered_product: null,
		searchWord: "",
		searchNumber: "",
		orderComponent: {
			product_id: "",
			component_id: "",
			ordered_product_id: "",
			quantity: "",
			remarks: "",
			unit_price: "",
		},
		uploadFiles: [],
		searchedComponents: [],
		selectedComponent: null,
	}
}

export default {
	components: { DragUpload },
	props: {
		orderedProduct: {
			product_id: "",
			id: "",
		},
	},
	data() {
		return initialState()
	},
	methods: {
		openDialog() {
			this.dialog = true
		},
		setComponent(component) {
			this.selectedComponent = component
			this.orderComponent.product_id = this.orderedProduct.product_id
			this.orderComponent.ordered_product_id = this.orderedProduct.id
			this.orderComponent.component_id = component.id
			this.searchedComponents = []
		},
		resetComponent() {
			this.selectedComponent = null
			this.orderComponent = {
				product_id: "",
				component_id: "",
				ordered_product_id: "",
				quantity: "",
			}
		},
		searchComponent() {
			let th = this
			async function main() {
				let response = await th.common.searchComponents(th.searchWord, th.searchNumber)
				th.searchedComponents = response.data.components
			}
			main()
		},
		fileShare(files) {
			this.uploadFiles = files
		},
		componentInfo(component) {
			return (
				"品番：" +
				component.part_number +
				"\n品名：" +
				component.name +
				"\nワイルドカード：" +
				this.common.returnMaruBatsu(component.wildcard) +
				"\n概要：" +
				component.description
			)
		},
		resetData() {
			Object.assign(this.$data, initialState())
		},
		createOrderComponent() {
			const headers = authenticate.setHeader()
			const formData = new FormData()
			const config = { headers: { "content-type": "multipart/form-data" } }
			formData.append("order_component", JSON.stringify(this.orderComponent))
			axios
				.post("/erp/v1/parts_list/order_components.json", formData, { headers })
				.then((res) => {
					let createdOrderComponent = res.data.order_component
					console.log(createdOrderComponent)
					this.uploadFiles.forEach((file) => {
						this.fileUpload(file, createdOrderComponent.id)
					})
					this.$store.commit("setFlash", {
						type: "notice",
						text: "部品情報を追加しました。",
					})
					this.$emit("reloadIndex")
					this.resetData()
					this.dialog = false
				})
				.catch((err) => {
					if (err.response?.status == 400) {
						this.errors = err.response.data.errors
					}
					errorHandling.errorResponse(err)
				})
		},
		fileUpload(file, order_component_id) {
			const headers = authenticate.setHeader()
			headers["content-type"] = "multipart/form-data"
			const formData = new FormData()
			formData.append("order_component_id", order_component_id)
			formData.append("file", file)
			axios
				.post("/erp/v1/parts_list/files", formData, { headers })
				.then((res) => {
					if (!res.data.no_error) {
						this.$store.dispatch("setFlash", {
							text: res.data.miss_file + "の作成に失敗しました",
							type: "alert",
						})
					}
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
	},
	computed: {},
}
</script>

<style lang="scss" scoped>
.v-input--selection-controls {
	margin-top: 0;
}
</style>
